import React from 'react';
import ReactDOM from 'react-dom/client';
import { MemoryRouter, BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import About from './About';
import PrivacyPolicy from './Privacy';
import reportWebVitals from './reportWebVitals';
import TotalTenPromo from './Promo';
import { startAnalytics } from './analytics';
import { startHistorySync } from './historySync';

// Check for app build via env variable
const isAppBuild = process.env.REACT_APP_EMBEDDED === 'true';
const Router = isAppBuild ? MemoryRouter : BrowserRouter;

// Website only, and off the critical path - it decides for itself whether it
// should run, and loads nothing at all inside the iOS app. See analytics.js.
startAnalytics();

// The mirror image: app only, and a no-op anywhere the native handler is not
// installed - including older builds of the app. See historySync.js.
startHistorySync();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/promo" element={<TotalTenPromo />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
